export default __webpack_public_path__ + "static/media/threadedcomp.f7b919a2.webp";